import { Icon as PepperIcon } from "@pepperstone/pepper-ui-kit";
import clsx from "clsx";
import { classNames } from "@repo/ui";
import type { HTMLAttributes, ReactNode } from "react";
import { Icon } from "@/components/general/icon/Icon";
import { EIcon } from "@/utils/enums";
import styles from "./InfoBox.module.css";

type InfoBoxProps = {
  title: string;
  description: ReactNode;
  onClose?: () => void;
  variant?: "info" | "warning";
} & Omit<HTMLAttributes<HTMLDivElement>, "title">;

export const InfoBox = ({
  title,
  description,
  onClose,
  className,
  variant = "info",
  ...props
}: InfoBoxProps) => {
  return (
    <div
      {...props}
      role="note"
      className={classNames([
        styles.container,
        variant === "warning" && styles.warning,
        className,
      ])}
    >
      <span className={styles.iconWrapper} aria-hidden="true">
        {variant === "warning" ? (
          <PepperIcon
            icon="alert-circle"
            color="inherit"
            style={{
              color: "var(--color-text-warning, #bf7109) !important",
              paddingTop: "var(--spacing-xxs)",
            }}
            size="small"
          />
        ) : (
          <Icon name={EIcon.InformationBlue} className={styles.icon} />
        )}
      </span>
      <div className={styles.content}>
        <span className={styles.title}>{title}</span>
        <div
          className={
            variant === "warning"
              ? clsx(styles.description, styles.warningDescription)
              : styles.description
          }
        >
          {description}
        </div>
      </div>
      {onClose && (
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close"
          type="button"
        >
          <Icon name={EIcon.Close} className={styles.closeIcon} />
        </button>
      )}
    </div>
  );
};
